import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import { appRoutes } from "lib/appRoutes";
import { encodeCompressed } from "lib/hooks/useURLState";
import { SavedViewDataTypeUnion } from "lib/types/savedViews";

type ViewAllButtonProps = {
  filters?: { dataTypes?: SavedViewDataTypeUnion[] };
  title?: string;
  fullWidth?: boolean;
};

function ViewAllButton({ filters, title, fullWidth }: ViewAllButtonProps) {
  const encodedFilters = encodeCompressed(filters);
  const search = encodedFilters ? { savedSearchFilters: encodedFilters } : undefined;

  return (
    <ViewAllButtonWrapper>
      <Button
        as="a"
        {...appRoutes.savedSearches}
        search={search}
        buttonType="secondary"
        fullWidth={fullWidth}
      >
        {title || "View all"}
      </Button>
    </ViewAllButtonWrapper>
  );
}

const ViewAllButtonWrapper = styled.div({
  display: "flex",
  width: "100%",
  flexShrink: 0,
});

export default ViewAllButton;
